module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAAEEfUpiAAAABGdBTUEAALGPC/xhBQAAAPRJREFUWAntVl0OwiAMHsuuYPSEcCY4ocY7iLDQWSndhtUsMd1Lu6+lpX/AMJTPex8zOwIA1IAEgIWygkUDGN4GaBBaGyf7qlfIFd4sZv8hhCsG5S42LfRl6jebNDjmmoe6GGNu1tpLLc//m1G2FmFMbKAvjdh14accXwOfoRjjucgeSe/e0vuHJLbiylieC8iBc44NVVxGNfCFYRLPgrgK7DClJjqlfpodrA0c22HaidyMUlxcRrYK1NcLwRUCdO3uAJ0WFUfQMtqD6QY0A6Z+Fe5pIHzQIX329YB0CDvB1Usk/cD4ia3De0APosNLoBvQDDwB8xpiay7qAIoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/shape_plus_lightgray_transparent_16_16.png
// module id = ./src/_asset/sources/assets/images/shape_plus_lightgray_transparent_16_16.png
// module chunks = main